import React, { useEffect, useState, useContext } from "react";
import DateFnsUtils from '@date-io/date-fns'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import Validation from "./Validation";
import {ThemeContext} from '../Helper/Context'
window.scrollTo(0, 0)
const Editchild = ({childId, onSubmit}) => {
    // const [selectedDate, handleDateChange] = useState(new Date());
    const {mainState, setMainState} = useContext(ThemeContext);
    const [errors, setErrors] = useState ({errors:true})
    const [child, setChild] = useState (
        {
            id:childId.id,
            selected:true,
        },
    )
    const formatDate = (e) =>{
        let childDate = mainState.children[childId.id].birthDate
        let formatedDate = (parseInt(childDate.split('/')[1].split('/')[0])+1)+'/'+childDate.split('/')[0]+'/'+childDate.split('/').pop();
        return new Date(formatedDate);
    }
    const [formFields, setFormFields] = useState({
        firstName:{
            value:mainState.children[childId.id].firstName,
            required: true,
            type:'text'
        },
        lastName:{
            value:mainState.children[childId.id].lastName,
            required: true,
            type:'text'
        },
        birthDate:{
            value:formatDate(),
            required: true,
            type:'text'
        },
        gender:{
            value:mainState.children[childId.id].gender,
            required: true,
            type:'radio'
        },
        phoneNumber:{
            value:mainState.children[childId.id].phoneNumber,
            required: true,
            type:'text'
        },
        citizenship:{
            value:mainState.children[childId.id].citizenship,
            required: true,
            type:'text'
        },
        healthIssueDetails:{
            value:mainState.children[childId.id].healthIssueDetails,
            required: true,
            type:'text'
        },
        
    })
    const handleDate = (seletedDate) =>{
        let formatedDate = ("0" + seletedDate.getDate()).slice(-2)+'/'+seletedDate.getMonth()+'/'+seletedDate.getFullYear();
        setFormFields(prevState =>({
            ...prevState,
            birthDate:{
                ...prevState.birthDate, value:seletedDate
            }
        }))

        mainState.children[childId.id].birthDate = formatedDate

        setMainState({...mainState});
        
    }

    const handleRadioButton = (e) =>{
        if(e === formFields.gender.value)  return true;
    }

    const handleChange = (e) =>{
        setFormFields(prevState =>({
            ...prevState,
            [e.target.name]:{
                ...prevState[e.target.name], value:e.target.value
            }
        }))
        mainState.children[childId.id][e.target.name] = e.target.value
        setMainState({...mainState});
    }

    const handleFormSubmit = (e) =>{
        e.preventDefault();
        setErrors(Validation(formFields));
               
    }

    const updateChildren = (e) =>{
        onSubmit(false, false, true);
    }

    useEffect(() => {
        if(!errors){
            updateChildren()
        }
    },[errors]);
    
    return (
        <>
            <p>Please review the current details about your child, make any changes and confirm.</p>

            <h2>Your child details:</h2>
            {/* <h2>Your personal details</h2> */}
            <div className="form">
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="firstname">First name</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="firstname" name="firstName" placeholder="Type your first name" 
                            value={mainState.children[childId.id].firstName}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.firstName &&
                        <span className="EditingFormErrorLabel">Please enter first name</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="lastname">Last name</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="lastname" name="lastName" placeholder="Type your last name" 
                            value={mainState.children[childId.id].lastName}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.lastName &&
                        <span className="EditingFormErrorLabel">Please enter last name</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="dateOfBirth">Birth date</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control datepickercontrol">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                            variant="inline"
                            format="dd/MM/yyyy"
                            value={formFields.birthDate.value} 
                            onChange={date => handleDate(date)}
                            />
                        </MuiPickersUtilsProvider>
                        </div>
                        {errors.birthDate &&
                        <span className="EditingFormErrorLabel">Please enter valid birth date</span>
                        }
                    </div>
                </div>                
                <div className="form-row">
                    <div className="form-element">
                        <span className="label">Gender</span>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <span className="radio radio-list-horizontal">
                            <input id="Male" type="radio" name="gender" 
                                checked={handleRadioButton('Male')} 
                                defaultValue="Male" onChange={e => handleChange(e)}/>
                                <label htmlFor="Male">Male</label>

                                <input id="Female" type="radio" name="gender"
                                checked={handleRadioButton('Female')} 
                                defaultValue="Female" onChange={e => handleChange(e)}/>
                                <label htmlFor="Female">Female</label>

                                <input id="Intersex" type="radio" name="gender"
                                checked={handleRadioButton('Intersex')} 
                                defaultValue="Intersex" onChange={e => handleChange(e)}/>
                                <label htmlFor="Intersex">Intersex</label>
                            </span>
                        </div>
                        {errors.gender &&
                        <span className="EditingFormErrorLabel">Please enter gender</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="phoneNumber">Phone number</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="phoneNumber" name="phoneNumber" placeholder="0400 000 000" 
                            value={mainState.children[childId.id].phoneNumber}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.phoneNumber &&
                        <span className="EditingFormErrorLabel">Please enter phone number</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="citizenship">Citizenship</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="citizenship" name="citizenship" placeholder="Type your citizenship" 
                            value={mainState.children[childId.id].citizenship}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.citizenship &&
                        <span className="EditingFormErrorLabel">Please enter citizenship</span>
                        }
                    </div>
                </div>
                <h3>Health Issues</h3>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="healthIssueDetails">Health Issue detail:</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <textarea rows={2} cols={20} className="form-control" autoComplete="off" name="healthIssueDetails" id="healthIssueDetails"
                            placeholder="Please type"
                            value={mainState.children[childId.id].healthIssueDetails}
                            onChange={e => handleChange(e)}/>
                        </div>
                        {errors.healthIssueDetails &&
                        <span className="EditingFormErrorLabel">Please write health issue detail</span>
                        }
                        
                    </div>
                </div>
                <div className="form-row form-row-submit">
                    <div className="form-element">
                        <div className="btn-wrapper">
                        <button className="FormButton btn" value="Done" onClick={(e) => handleFormSubmit(e)} >Done</button>
                        <button className="btn btn-border" onClick={(e) => onSubmit(false, false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    )
}

export default Editchild